export default __webpack_public_path__ + "../staticImages/pdp-bg-default-m-dark.webp";